/**
 * #534 — the failed-log text for an error that escapes `retrySendMessageThunk`.
 *
 * That catch used to print to the console only, so the message's logs simply stopped and the reaper
 * read it as "the engine went silent". The text names the error CLASS (constructor name, HTTP status
 * when the backend answered) plus a bounded, single-line message. Prefixed so it can't be mistaken
 * for a send failure. Pure so it is unit-testable.
 */
export const RETRY_THUNK_ERROR_PREFIX = 'Retry thunk error';
const MESSAGE_MAX = 160;

const isObject = (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null;

/** `Name[ http=<status>][ — <message ≤160, single line>]`, with no prefix. Shared by every error-bearing trace row. */
export function describeError(error: unknown): string {
    const name = error instanceof Error ? error.name : error === null ? 'null' : typeof error;
    const response = isObject(error) && isObject(error.response) ? error.response : undefined;
    const status = typeof response?.status === 'number' ? ` http=${response.status}` : '';
    const raw = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
    const message = raw.replace(/\s+/g, ' ').trim().slice(0, MESSAGE_MAX);
    return `${name}${status}${message ? ` — ${message}` : ''}`;
}

export function retryThunkErrorReason(error: unknown): string {
    return `${RETRY_THUNK_ERROR_PREFIX}: ${describeError(error)}`;
}
